import { useEffect, useRef } from 'react';

/**
 * Custom hook over useEffect which ignores the very first execution.
 *
 * Note, you do not get any static dependency checking here, you must double
 *       check as ESLint cannot handle dependencies passed in as an argument.
 *
 * @param {Function} callback
 * @param {Array} dependencies
 */
export default function useEffectSkipFirst(callback, dependencies, first = true) {
    /* eslint-disable react-hooks/exhaustive-deps, consistent-return */
    const firstTime = useRef(first);

    useEffect(() => {
        if (firstTime.current) {
            firstTime.current = false;
            return;
        }

        return callback();
    }, dependencies);
}
